import type { UseFormReturn } from 'react-hook-form';

import { calculateFinalTerminationDate, calculateTerminationDate } from './termination-helpers';

import type { PartnerFormSchema } from '../schemas';

/**
 * Custom hook to handle automatic calculation of termination dates
 * Calculates termination dates on-the-fly when form values change
 * @param form - React Hook Form instance
 */
export function useTerminationLogic(form: UseFormReturn<PartnerFormSchema>) {
  // Watch the fields that affect termination date calculations
  const [noticeDate, requiredPeriodDays, overrideDate, extensionDays] = form.watch([
    'termination_notice_date',
    'required_notice_days',
    'override_termination_date',
    'termination_extension_days',
  ]);

  // Calculate termination dates on-the-fly
  // React automatically re-runs this when watched form values change
  const calculatedTerminationDate = calculateTerminationDate(noticeDate, requiredPeriodDays);
  const finalTerminationDate = calculateFinalTerminationDate(calculatedTerminationDate, overrideDate, extensionDays);

  form.setValue('calculated_termination_date', calculatedTerminationDate);
  form.setValue('final_termination_date', finalTerminationDate);

  return {
    calculatedTerminationDate,
    finalTerminationDate,
  };
}
